import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { NavLink } from "react-router-dom";
import pack from "../../../../package.json";
import Headtler_ERP from "../../../Assets/icons/Headtler_ERP.png";
import hamberger from "../../../Assets/icons/hamberger.png";
import Image from "../Image/Image";
import Drawerpages from "./Drawerpages/Drawerpages";
import "./HamburgerDrawer.scss";

function HamburgerDrawer() {
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(true);
  const [quickLinks, setQuickLinks] = useState([]);
  const [userData, setUserData] = useState(() => JSON.parse(sessionStorage.getItem("userData")) || null);

  const toggle = () => {
    setIsOpen((prev) => !prev);
    dispatch({ type: "set_sidebarOpen", payload: isOpen });
  };

  useEffect(() => {
    // 1) On mount, read from sessionStorage:
    const userDataStr = sessionStorage.getItem("userData");
    if (userDataStr) {
      const userData = JSON.parse(userDataStr);
      if (userData?.BookMarks) {
        setQuickLinks(userData.BookMarks);
      }
    }

    // 2) Listen for our custom "sessionStorageUpdated" event:
    function handleSessionStorageUpdate() {
      // Re-read from sessionStorage:
      const updatedDataStr = sessionStorage.getItem("userData");
      if (updatedDataStr) {
        const updatedData = JSON.parse(updatedDataStr);
        if (updatedData?.BookMarks) {
          setQuickLinks(updatedData.BookMarks);
        }
      }
    }

    window.addEventListener("sessionStorageUpdated", handleSessionStorageUpdate);

    // 3) Cleanup the event listener on unmount
    return () => {
      window.removeEventListener("sessionStorageUpdated", handleSessionStorageUpdate);
    };
  }, []);

  return (
    <div>
      <div className={isOpen ? "togglebar" : "changetogglebar"}>
        <div className="logo">
          <Image name={!isOpen ? "hidelogo" : "showlogo"} width={"122px"} height={"40px"} img={Headtler_ERP} />
        </div>
        <Image toggle={toggle} height={"18px"} img={hamberger} />
      </div>

      <div className={`drawer ${isOpen ? "open" : "closed"}`}>
        <div className="drawerDiv">
          <div className="drawerbox">
            <Drawerpages data={{ Page_Name: "Dashboard", Route: "" }} name="inactive" />
          </div>
          {quickLinks.length > 0 &&
            quickLinks.map((e, i) => (
              <div key={i} className="drawerbox">
                {e.Page_Rights.map((element, index) => (
                  <Drawerpages key={index} data={element} name="inactive" />
                ))}
              </div>
            ))}
        </div>
        <div className="RequestSupportDiv">
          <div>
            <NavLink className="RequestSupportLink" to={"/RequestSupport"}>
              Support Request
            </NavLink>
          </div>
          {pack.version}
        </div>
      </div>
    </div>
  );
}

export default HamburgerDrawer;
